export default __webpack_public_path__ + "static/media/us-ri.33d57111.svg";